var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"wrapper-content"},[_c('LmDataTable',{attrs:{"slug":_vm.$route.params.slug || _vm.slug}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }